import React from 'react';
import { toast } from 'react-toastify';
import { ItemToSchedule } from '../../../contexts/ModuleContext';
import { PatientProps } from '../../../contexts/PatientContext';
import { Payment } from '../../../models/Schedule';
import { ScheduleSpecialist } from '../../../models/ScheduleSpecialist';
import { Specialist, SpecialistUnit } from '../../../models/Specialist';
import { fetchRuleValidationSpecialist } from '../../../modules/validateRules';
import { InternalStatusCode } from '../../../utils/enums/validate-rules.enum';
import { FirebaseEvents } from '../../../utils/enums/firebase-events';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { useServiceContext } from '../../../contexts/ServiceContext';

type useAttendaceTypeSpecialistProps = {
  selectedSpecialist?: Specialist;
  selectedItemToSchedule: ItemToSchedule;
  scheduleSpecialistSelected: ScheduleSpecialist;
  setLoadingChangeProduct: React.Dispatch<React.SetStateAction<boolean>>;
  patientSelected?: PatientProps;
};

export const useAttendaceTypeSpecialist = ({
  patientSelected,
  scheduleSpecialistSelected,
  setLoadingChangeProduct,
  selectedSpecialist,
  selectedItemToSchedule
}: useAttendaceTypeSpecialistProps) => {
  const [coveragesSpecialist, setCoveragesSpecialist] = React.useState({
    presential: [] as SpecialistUnit[],
    telemedicine: [] as SpecialistUnit[],
    eav: [] as SpecialistUnit[]
  });

  const [specialistUnitSelected, setSpecialistUnitSelected] = React.useState<SpecialistUnit>();

  const { selectedService } = useServiceContext();

  const { logEvent } = useAnalytics();

  const validateRulesSpecialist = async ({
    patient,
    office_id,
    specialist_id,
    payment
  }: {
    patient: PatientProps;
    office_id: string;
    specialist_id: string;
    payment: Payment;
  }) => {
    const result = await fetchRuleValidationSpecialist({
      patient,
      payment,
      specialist: {
        office_id,
        specialist_id
      }
    });

    if (result.data.statusCode === InternalStatusCode.OK) return true;
    toast.error('Não foi possível selecionar a unidade.');
    return false;
  };

  const onSelectUnitSpecialist = async (unit: SpecialistUnit) => {
    setLoadingChangeProduct(true);

    logEvent({
      eventName: FirebaseEvents.schedule_selected_unit,
      eventParams: {
        service_id: selectedService.id,
        service_name: selectedService.name,
        product_id: selectedSpecialist?.id,
        product_name: selectedSpecialist?.name,
        unit_id: unit.id,
        unit_name: unit.name
      }
    });

    const { payment, idPatient } = scheduleSpecialistSelected;
    if (selectedSpecialist?.id && payment && idPatient) {
      const patient = patientSelected;
      if (patient) {
        const isValidSchedule = await validateRulesSpecialist({
          office_id: unit.office_id,
          specialist_id: selectedSpecialist?.id,
          patient: patient,
          payment: payment
        });
        if (isValidSchedule) setSpecialistUnitSelected(unit);
      }
    }
    setLoadingChangeProduct(false);
  };

  React.useEffect(() => {
    if (selectedItemToSchedule === 'SPECIALIST') {
      const coverages = {
        presential: [] as SpecialistUnit[],
        telemedicine: [] as SpecialistUnit[],
        eav: [] as SpecialistUnit[]
      };
      selectedSpecialist?.units.map(item => {
        if (item.schedule_types?.some(type => type.name === 'Autoagendamento')) {
          if (item.attendance.telemedicine) {
            coverages.telemedicine = [...coverages.telemedicine, item];
          }
          if (item.attendance.presential) {
            coverages.presential = [...coverages.presential, item];
          }
          if (item.attendance.eav) {
            coverages.presential = [...coverages.eav, item];
          }
        }

        setCoveragesSpecialist(coverages);
      });
    }
  }, []);
  return {
    coveragesSpecialist,
    onSelectUnitSpecialist,
    specialistUnitSelected,
    setSpecialistUnitSelected
  };
};
